export default __webpack_public_path__ + "static/9-6f01a8f5a52909a089725e86714ad879.jpg";